export enum ROUTES_PATH {
  LANDING = "/",
  ENTRY = "/entry",
  ENTITIES = "/entities",
  LOGIN = "/login",
  SUCCESS = "/success",
  LOADING = "/loading",
  LOGIN_ERROR = "/login-error",
  UNKNOWN_ERROR = "/unknown-error",
}

export const REDIRECTION_URL = 'https://pepperfinance.es/';


export const allBanks = [
  {
    name: "Abanca",
    logo: "Abanca.svg",
  },
  {
    name: "Activobank",
    logo: "ActivoBank.svg",
  },
  {
    name: "BBVA",
    logo: "BBVA.svg",
  },
  {
    name: "Banco Cooperativo",
    logo: "DefaultBank.svg",
  },
  {
    name: "Banco Pichincha",
    logo: "BancoPichincha.svg",
  },
  {
    name: "Banco Sabadell",
    logo: "BancSabadell.svg",
  },
  {
    name: "Banco Santander",
    logo: "Santander.svg",
  },
  // {
  //   name: "Banca March",
  //   logo: "BancaMarch.svg",
  // },
  // {
  //   name: "Banco Caminos",
  //   logo: "BancoCaminos.svg",
  // },
  {
    name: "Bankinter",
    logo: "Bankinter.svg",
  },
  {
    name: "BankinterCard",
    logo: "DefaultBank.svg",
  },
  {
    name: "Bnext",
    logo: "BNext.svg",
  },
  {
    name: "CRC",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caixa Popular",
    logo: "CaixaPopular.png",
  },
  {
    name: "Caixa Rural Benicarlo",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caixa Rural Galega",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caixa Rural Les Coves",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caixa Vinaros",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaBank",
    logo: "Caixabank.svg",
  },
  {
    name: "CaixaCallosa",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaPetrer",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaRuralAlmenara",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaRuralBurriana",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaRuralDeXilxes",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaRuralNules",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaRuralTorrent",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaRuralVilafames",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaRuralVilareal",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaRuralVilavilla",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaSantVicent",
    logo: "DefaultBank.svg",
  },
  {
    name: "CaixaTuris",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural",
    logo: "CajaRural.svg",
  },
  {
    name: "Caja Rural Adamuz",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Albal",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Algemesi",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Aragon",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Asturias",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Baena",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Casas Ibañez",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Cañete De Las Torres",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Del Sur",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural El Salvador Vinaroz",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Extremadura",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural FuenteAlamo",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Gijon",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Granada",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Jaen",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural L'Alcudia",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Navarra",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Nueva Carteya",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Onda",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Orihuela",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Salamanca",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural San Isidiro Les Coves Vinroma",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural San Isidro Vall d'Uxo",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural San Jose Alcora",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural San Jose De Almassora",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Soria",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Teruel",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Utrera",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Villamalea",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Rural Zamora",
    logo: "DefaultBank.svg",
  },
  {
    name: "Caja Viva",
    logo: "CajaViva.png",
  },
  {
    name: "CajaSiete",
    logo: "CajaSiete.png",
  },
  {
    name: "Cajamar",
    logo: "Cajamar.svg",
  },
  {
    name: "Cajasur",
    logo: "CajaSur.svg",
  },
  {
    name: "Cetelem",
    logo: "DefaultBank.svg",
  },
  {
    name: "Deutsche Bank",
    logo: "DeutscheBank.svg",
  },
  {
    name: "EVO Banco",
    logo: "Evo.svg",
  },
  {
    name: "El Corte Inglés",
    logo: "DefaultBank.svg",
  },
  {
    name: "Eurocaja Rural",
    logo: "EurocajaRural.png",
  },
  {
    name: "Global Caja",
    logo: "GlobalCaja.png",
  },
  {
    name: "ING",
    logo: "IngDirect.svg",
  },
  {
    name: "IberCaja",
    logo: "Ibercaja.svg",
  },
  {
    name: "Imagin",
    logo: "Imaginbank.svg",
  },
  {
    name: "Kutxabank",
    logo: "Kutxabank.svg",
  },
  {
    name: "Laboral Kutxa",
    logo: "LaboralKutxa.png",
  },
  // {
  //   name: "Liberbank",
  //   logo: "Liberbank.svg",
  // },
  // {
  //   name: "Mediolanum",
  //   logo: "Mediolanum.svg",
  // },
  {
    name: "N26",
    logo: "N26.svg",
  },
  {
    name: "Openbank",
    logo: "Openbank.svg",
  },
  {
    name: "Revolut",
    logo: "Revolut.png",
  },
  {
    name: "RuralNostra",
    logo: "RuralNostra.png",
  },
  {
    name: "Ruralvia",
    logo: "Ruralvia.svg",
  },
  {
    name: "Selfbank",
    logo: "SelfBank.png",
  },
  // {
  //   name: "Triodos Bank",
  //   logo: "TriodosBank.svg",
  // },
  {
    name: "Unicaja",
    logo: "Unicaja.svg",
  },
  {
    name: "WiZink",
    logo: "Wizink.svg",
  },
];
